export default "__VITE_ASSET__DWTA85oc__"